"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextInputContainer = void 0;

var _native = _interopRequireDefault(require("styled-components/native"));

var _styledUtils = require("@sloth-system/styled-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

let TextInputContainer = _native.default.TextInput`
  background-color: ${(0, _styledUtils.color)("common.white")};
  padding: ${(0, _styledUtils.space)("l")};
  border-radius: ${(0, _styledUtils.radii)("s")};
  border-color: #ccc;
  border-width: 1;
  text-align: center;
  font-family: ${(0, _styledUtils.typography)("face.main")};
`;
exports.TextInputContainer = TextInputContainer;